import { Link } from "react-router-dom"
import DOMPurify from "dompurify";

const getAssetUrl = (path) => {
  if (!path) return "";
  if (String(path).startsWith("http")) return path;
  return `${process.env.REACT_APP_EXTERNAL_API_URL}/${String(path).replace(/^\/+/, "")}`;
};

const clampHtmlToPlainText = (html = "") =>
  String(DOMPurify.sanitize(String(html || ""), { ALLOWED_TAGS: [] }))
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();

function JobCardHorizontal({data,index}){
  const descriptionText = clampHtmlToPlainText(data?.description);
  return(
    <>
      <div key={data.title} className="bg-gray-50 px-4 py-4 rounded-lg shadow-xl group">
        <div className='mb-4'>
          <img className="h-48 w-full object-contain bg-white rounded-md" src={getAssetUrl(data.image)} alt={`Banner de ${data.title}`}/>
        </div>
        <Link to={`/empleos/${data.id}`} className="mt-4 block">
          <p className="text-xl font-semibold text-gray-700 group-hover:text-green-corpo line-clamp-1">{data.title}</p>
          <p className="mt-1 text-base font-semibold text-gray-500">Empresa: {data.user.enterprise}</p>
          <p className="mt-3 text-base text-gray-500 line-clamp-2">{descriptionText}</p>
        </Link>
        <div className="mt-4 flex items-center justify-center">
          <div className="">
            <Link to={`/empleos/${data.id}`}>
              <span className="bg-green-corpo hover:bg-green-700 transition ease-linear duration-75 text-white px-4 py-1.5 rounded-md">Ver oferta</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
export default JobCardHorizontal
